module.exports = __webpack_public_path__ + "img/hero2.aa4b31d4.webp";